import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { BankDisplayInSharePdf } from '../../../../../../api/types';

const useBankDisplayInSharePdfOptions = () => {
    const { t } = useTranslation('moduleDetails');

    return useMemo(
        () => [
            {
                value: BankDisplayInSharePdf.Hidden,
                label: t('moduleDetails:explanations.bankDisplayInSharePDF.hidden'),
            },
            {
                value: BankDisplayInSharePdf.FollowCalculator,
                label: t('moduleDetails:explanations.bankDisplayInSharePDF.followCalculator'),
            },
        ],
        [t]
    );
};

export default useBankDisplayInSharePdfOptions;
